import { has } from "../../../utils/menu-context";
import store from "../../../store";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return new RegExp(
                    `^surveyQuestions\\.[^\\.]+\\.questionChoices\\.[^\\.]+\\.(isCheck)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ componentKey }) => {
                return [
                    "SurveyQuestionList",
                ].includes(componentKey);
            },
            inputPropField: ({ props, modelRef }) => {
                const { viewOnly } = props;
                const userInfo = store.state.resource.auth.info?.user;
                let canCreate = false;
                let canDelete = false;
                if (modelRef.createBy == null) {
                    return { canCreate: !viewOnly || canCreate, canDelete: !viewOnly || canDelete }
                }

                if (userInfo.username == modelRef.createBy) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        },
    ];
};
